export default {
  user: {
    loggedIn: false,
    data: null
  },
  utilisateurs: [],
  modalAdduser: false,
  modalEdituser: false,
  modalDeleteuser: false,
  edituser: {},
  appartements: [],
  modalAddappart: false,
  modalEditappart: false,
  modalDeleteappart: false,
  modalZoomimg: false,
  editimgzoom: false,
  editappart: {},
  gestion: {},
  modalGestionappart: false,
  actualites: [],
  modalAddactualite: false,
  modalEditactualite: false,
  modalDeleteactualite: false,
  editactualite: {},
  realisations: [],
  modalAddrealisation: false,
  modalEditrealisation: false,
  modalDeleterealisation: false,
  editrealisation: {},
  devis: [],
  modalAdddevis: false,
  modalEditdevis: false,
  modalDeletedevis: false,
  modalClosedevis: false,
  modalViewdevis: false,
  editdevis: {}
}
